import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { AppHeaderComponent } from './common/app-header/app-header.component';
import { SessionDto } from '../core/models/session/sessiondto';
import { CommonService } from '../core/api/services/utility-services/common.service';
import { RoleConstants } from '../core/constants/role.constants';
import { NavigationBarComponent } from './common/navigation/navigation.component';
import { NgClass } from '@angular/common';
import { AppFooterComponent } from './common/app-footer/app-footer.component';
import {filter, take} from 'rxjs';
import {TimeoutService} from '../core/api/services/utility-services/timeout.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet,  NgClass, NavigationBarComponent, AppFooterComponent],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  title = 'ng-frontend';
  sessionDetails: SessionDto;
  readonly commonService = inject(CommonService);
  readonly router = inject(Router);
  readonly timeoutService = inject(TimeoutService);
  isPartner: boolean;
  showNavbar: boolean = true;
  showHeaderFooter: boolean = true;
  hideFooterOnMobile: boolean = false;
  lastSessionCheck: number;

  private isSmallScreen(): boolean {
    try {
      return window.innerWidth <= 1024;
    } catch (e) {
      return false;
    }
  }

  private restartTimer() {
    try {
      const currentTime = new Date().getTime();
      if (!this.lastSessionCheck || currentTime - this.lastSessionCheck > 2000) {
        this.lastSessionCheck = currentTime;
        this.commonService.sessiondetails?.pipe(take(1)).subscribe(res => {
          const activeSession = res?.sessionId !== undefined;
          if(activeSession) {
            this.timeoutService.restartTimer();
          }
        })
      }
    } catch (e) {
      //Do nothing and don't remove
    }
  }

  ngOnInit() {
    this.timeoutService.setupTimeout(15*60);
    // Load session on app initialization
    this.commonService.session().subscribe();
    this.commonService.sessiondetails.subscribe(res => {
      this.sessionDetails = res
      this.isPartner = res && res.userRoles?.includes(RoleConstants.PARTNER);
      const activeSession = res?.sessionId !== undefined;
      if(activeSession) {
        this.restartTimer();
      }
      else {
        this.timeoutService.stopTimer();
      }
    })

    document.body.addEventListener("click", async () => {
      this.restartTimer();
    });

    const hideFooterRoutes = ['/login', '/forgot-password', '/forgot-username'];


    // Track route changes to hide navbar on auth pages (login, registration, unauthorized)
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.showNavbar = !event.url.includes('/login') && !event.url.includes('/registration')
          && !event.url.includes('/forgot-password') && !event.url.includes('/forgot-username');

        // Hide header and footer on healthStatus page
        this.showHeaderFooter = !event.url.includes('/healthStatus');
        // Hide footer on small screens for specific auth pages
        this.hideFooterOnMobile = hideFooterRoutes.some(r => event.url.includes(r)) && this.isSmallScreen();
      });

    // Update hideFooterOnMobile on window resize so the class takes effect responsively
    window.addEventListener('resize', () => {
      // re-evaluate based on current url
      const url = this.router.url || '';
      this.hideFooterOnMobile = hideFooterRoutes.some(r => url.includes(r)) && this.isSmallScreen();
    });

  }
}
